var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-toolbar",
                        {
                          attrs: {
                            color: "primary",
                            dark: "",
                            dense: "",
                            flat: ""
                          }
                        },
                        [
                          _c("span", [_vm._v("New Purchase Requisition")]),
                          _c("v-spacer"),
                          _c("v-icon", [_vm._v("mdi-account")]),
                          _c("v-icon", [_vm._v("mdi-plus")])
                        ],
                        1
                      ),
                      _vm._l(_vm.purchReqPostErrors, function(item, index) {
                        return _c(
                          "v-alert",
                          {
                            key: index,
                            staticClass: "mt-2",
                            attrs: { type: "error", dismissible: "" }
                          },
                          [
                            _c("span", { staticClass: "text-uppercase" }, [
                              _vm._v(_vm._s(item.first()))
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "PR ID", value: _vm.id, disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Status", value: "New", disabled: "" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date Submitted",
                          "error-messages":
                            _vm.purchaseRequestStorePostErrors.submitted_date,
                          type: "date"
                        },
                        model: {
                          value: _vm.submittedDate,
                          callback: function($$v) {
                            _vm.submittedDate = $$v
                          },
                          expression: "submittedDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Date Expected",
                          "error-messages":
                            _vm.purchaseRequestStorePostErrors.expected_date,
                          type: "date"
                        },
                        model: {
                          value: _vm.expectedDate,
                          callback: function($$v) {
                            _vm.expectedDate = $$v
                          },
                          expression: "expectedDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Amount", value: _vm.amount }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: { label: "Notes", outlined: "" },
                        model: {
                          value: _vm.notes,
                          callback: function($$v) {
                            _vm.notes = $$v
                          },
                          expression: "notes"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "primary",
                            dark: "",
                            loading: _vm.purchaseRequestStorePosting,
                            block: ""
                          },
                          on: { click: _vm.submitData }
                        },
                        [_c("span", [_vm._v("Save")])]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red", dark: "", block: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/purchase-request")
                            }
                          }
                        },
                        [_c("span", [_vm._v("Cancel")])]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "v-toolbar",
                { attrs: { color: "primary", dense: "", flat: "", dark: "" } },
                [_c("span", [_vm._v("Detail")])]
              ),
              _c("create-details", {
                model: {
                  value: _vm.details,
                  callback: function($$v) {
                    _vm.details = $$v
                  },
                  expression: "details"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }